import { render, staticRenderFns } from "./CharType.vue?vue&type=template&id=058a1230&scoped=true&"
import script from "./CharType.vue?vue&type=script&lang=js&"
export * from "./CharType.vue?vue&type=script&lang=js&"
import style0 from "./CharType.vue?vue&type=style&index=0&id=058a1230&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a1230",
  null
  
)

export default component.exports